import React, { Component } from 'react'
import { graphql } from 'gatsby'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import Seo from "../components/seo"
import { Logo } from '../components/logo'
import parse from 'html-react-parser'
import Link from '../utils/link'
import Fade from 'react-reveal/Fade'
import AgentListings from '../components/agent-listings'
import BoughtBlocks from '../components/BoughtBlocks'
import Offices from '../components/offices'
import Slider from 'react-slick'
import Plyr from '../components/plyr'
import AdvocacyLogo from '../assets/images/advocacy.svg'

const instagram_urls = {
  nz: 'https://www.instagram.com/whitefoxrealestate.nz/',
  aus: 'https://www.instagram.com/whitefoxrealestate/',
  perth: 'https://www.instagram.com/whitefox.perth/',
  adelaide: 'https://www.instagram.com/whitefox.adelaide/',
  gc: 'https://www.instagram.com/whitefox.gc/',
  brisbane: 'https://www.instagram.com/whitefox.bris'
}

class ImTemplate extends Component {

  constructor(props) {
    super(props)
    this.props.data.current.edges = this.props.data.current.edges.filter(el => el.node.propertyData.consultant_ids.indexOf(this.props.data.wpTeam.boxId) !== -1)
    this.props.data.sold.edges = this.props.data.sold.edges.filter(el => el.node.propertyData.consultant_ids.indexOf(this.props.data.wpTeam.boxId) !== -1)

    this.props.data.current.edges.sort((a, b) => new Date(b.node.date) - new Date(a.node.date))
    this.props.data.sold.edges.sort((a, b) => new Date(b.node.date) - new Date(a.node.date))
    this.state = {
      isLightboxOpen: false,
      lightboxIndex: 0
    }
  }

  closeLightbox = () => {
    this.setState({ isLightboxOpen: false })
  }

  render() {
    const team = this.props.data.wpTeam
    const page = this.props.data.wpIm
    const settings = this.props.data.wp.siteSettings.acf
    page.acf.advocacy && settings.imExpertise.items.unshift(settings.imExpertise.items.pop())

    let mobile = team.acf.mobile ? team.acf.mobile : team.teamData.mobile
    let email = team.acf.email ? team.acf.email : team.teamData.email

    const sliderSettings = {
      autoplay: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }

    const videosSettings = {
      autoplay: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }

    const pillarSettings = {
      autoplay: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }

    return (
      <>
        <Seo bodyClass={`single-agent single-agent--im`} {...page.seo} />
        <header className='single-agent__header'>
          <div className='single-agent__inner'>
            <div className='single-agent__header-left'>
              <Link className='single-agent__logo' to='/'>
                <Logo />
              </Link>
              <div className='single-agent__header-content'>
                {page.title && <h4>{parse(page.title)}</h4> }
                <p>WHITEFOX {page.acf.office ? page.acf.office : ''}</p>
              </div>
            </div>
            <div className='single-agent__header-right'>
              <ul className='single-agent__header-social'>
                <li>
                  <Link to={instagram_urls[process.env.GATSBY_LOCATION]}>
                    <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <g stroke="none" strokeWidth="1" fill="#64656A" fillRule="evenodd">
                        <path d="M9.49998114,1.71174636 C12.0366028,1.71174636 12.3370409,1.7214002 13.3387775,1.7671051 C14.2650181,1.80937836 14.7680359,1.96414147 15.1028281,2.09420432 C15.5462259,2.26654044 15.8627285,2.47243873 16.1951449,2.8048551 C16.5275613,3.13727148 16.7334596,3.45377411 16.905758,3.89717193 C17.0358585,4.23196405 17.1906216,4.73498187 17.2328949,5.66118478 C17.2785998,6.66295915 17.2882536,6.96339718 17.2882536,9.50001886 C17.2882536,12.0366405 17.2785998,12.3370786 17.2328949,13.3388152 C17.1906216,14.2650558 17.0358585,14.7680737 16.905758,15.1028658 C16.7334596,15.5462636 16.5275613,15.8627662 16.1951449,16.1951826 C15.8627285,16.527599 15.5462259,16.7334973 15.1028281,16.9057957 C14.7680359,17.0358962 14.2650181,17.1906594 13.3387775,17.2329326 C12.3371917,17.2786375 12.0367537,17.2882913 9.49998114,17.2882913 C6.96320863,17.2882913 6.6627706,17.2786375 5.66118478,17.2329326 C4.73494416,17.1906594 4.23192634,17.0358962 3.89717193,16.9057957 C3.4537364,16.7334973 3.13723377,16.527599 2.80481739,16.1951826 C2.47240102,15.8627662 2.26650273,15.5462636 2.09420432,15.1028658 C1.96410375,14.7680737 1.80934065,14.2650558 1.76706739,13.3388529 C1.72136249,12.3370786 1.71170865,12.0366405 1.71170865,9.50001886 C1.71170865,6.96339718 1.72136249,6.66295915 1.76706739,5.66122249 C1.80934065,4.73498187 1.96410375,4.23196405 2.09420432,3.89717193 C2.26650273,3.45377411 2.47240102,3.13727148 2.80481739,2.8048551 C3.13723377,2.47243873 3.4537364,2.26654044 3.89717193,2.09420432 C4.23192634,1.96414147 4.73494416,1.80937836 5.66114707,1.7671051 C6.66292144,1.7214002 6.96335947,1.71174636 9.49998114,1.71174636 M10.54128,0.000865225888 C12.1959135,0.00420034831 12.5594447,0.0180487342 13.4168001,0.0571688291 C14.4280021,0.103326248 15.1185533,0.263896745 15.722861,0.498756552 C16.34757,0.741535524 16.8773621,1.06637213 17.405495,1.59450501 C17.9336279,2.1226379 18.2584645,2.65243003 18.5012434,3.27713902 C18.7361033,3.88144673 18.8966738,4.57199791 18.9428312,5.58319986 C18.989064,6.59643816 19,6.91995491 19,9.50001886 C19,12.0800828 18.989064,12.4035995 18.9428312,13.4168379 C18.8966738,14.4280398 18.7361033,15.118591 18.5012434,15.7228987 C18.2584645,16.3476077 17.9336279,16.8773998 17.405495,17.4055327 C16.8773621,17.9336656 16.34757,18.2585022 15.722861,18.5012812 C15.1185533,18.736141 14.4280021,18.8967115 13.4168001,18.9428689 C12.4035618,18.9891017 12.0800451,19 9.49998114,19 C6.9199172,19 6.59643816,18.9891017 5.58316215,18.9428689 C4.5719602,18.8967115 3.88140902,18.736141 3.27710131,18.5012812 C2.65239232,18.2585022 2.12260019,17.9336656 1.5944673,17.4055327 C1.06633442,16.8773998 0.741497814,16.34757 0.498718842,15.7228987 C0.263859035,15.118591 0.103288537,14.4280398 0.0571311187,13.4168379 C0.0180110239,12.5594824 0.00418963769,12.1959512 0.000862822864,10.5413177 L0.000862822864,8.45871998 C0.00418963769,6.80408652 0.0180110239,6.44055535 0.0571311187,5.58319986 C0.103288537,4.57199791 0.263859035,3.88144673 0.498718842,3.27713902 C0.741497814,2.65243003 1.06633442,2.1226379 1.5944673,1.59450501 C2.12260019,1.06637213 2.65239232,0.741535524 3.27710131,0.498756552 C3.88140902,0.263896745 4.5719602,0.103326248 5.58316215,0.0571688291 C6.44054954,0.0180487342 6.80405863,0.00420034831 8.45868453,0.000865225888 Z M9.51884921,4.63690476 C6.82263769,4.63690476 4.63690476,6.82263769 4.63690476,9.51884921 C4.63690476,12.2150607 6.82263769,14.4007937 9.51884921,14.4007937 C12.2150607,14.4007937 14.4007937,12.2150607 14.4007937,9.51884921 C14.4007937,6.82263769 12.2150607,4.63690476 9.51884921,4.63690476 Z M9.51884921,6.34985912 C11.269013,6.34985912 12.6878393,7.76868543 12.6878393,9.51884921 C12.6878393,11.269013 11.269013,12.6878393 9.51884921,12.6878393 C7.76868543,12.6878393 6.34985912,11.269013 6.34985912,9.51884921 C6.34985912,7.76868543 7.76868543,6.34985912 9.51884921,6.34985912 Z M14.551606,3.2797619 C13.9269924,3.2797619 13.4206349,3.786082 13.4206349,4.41069558 C13.4206349,5.03530916 13.9269924,5.54166667 14.551606,5.54166667 C15.1762196,5.54166667 15.6825397,5.03530916 15.6825397,4.41069558 C15.6825397,3.786082 15.1762196,3.2797619 14.551606,3.2797619 Z"></path>
                      </g>
                    </svg>
                  </Link>
                </li>
                <li>
                  <Link to='https://au.linkedin.com/company/whitefoxrealestate'>
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M0.513672 18.1855H4.21097V5.80786H0.513672V18.1855Z" fill="#64656A"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M6.41895 5.69995H19V18.1856H6.41895V5.69995Z" fill="white"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M14.2757 5.69995C12.1703 5.69995 10.8357 6.89424 10.5789 7.76281V5.80852H6.41895C6.47081 6.83995 6.41895 18.1857 6.41895 18.1857H10.5789V11.5085C10.5789 11.1285 10.5789 10.7485 10.6811 10.4771C10.9897 9.71709 11.5541 8.95709 12.6838 8.95709C14.1216 8.95709 14.7892 10.0971 14.7892 11.78V18.1857H19V11.2914C18.9492 7.49138 16.8951 5.69995 14.2757 5.69995Z" fill="#64656A"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M2.25995 0C0.873461 0 0.000488281 0.922857 0.000488281 2.17143C0.000488281 3.36571 0.873461 4.28857 2.20808 4.28857H2.25995C3.64643 4.28857 4.51889 3.36571 4.51889 2.11714C4.46806 0.922857 3.64643 0 2.25995 0Z" fill="#64656A"/>
                    </svg>
                  </Link>
                </li>
                <li>
                  <Link to='https://www.youtube.com/channel/UCLBoneL_8xcxofKSaElesCQ'>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="20" height="20" rx="2" fill="#64656A"/>
                      <path d="M12.6732 9.63218C12.899 9.79154 12.899 10.1265 12.6732 10.2858L7.63062 13.8441C7.36565 14.0311 7 13.8416 7 13.5173L7 6.4007C7 6.0764 7.36565 5.8869 7.63062 6.07388L12.6732 9.63218Z" fill="white"/>
                    </svg>
                  </Link>
                </li>
              </ul>
              <ul className='single-agent__header-buttons'>
                <li><Link className='btn' to='https://sellmyproperty.whitefoxrealestate.com.au/'>Sell My Home</Link></li>
              </ul>
            </div>
          </div>
        </header>
        <section className='home-banner home-banner--video' data-color={'#FFFFFF'}>
          <video autoPlay playsInline muted loop disableRemotePlayback>
            <source src={settings.imVideo} type='video/mp4' />
          </video>
          <div className='home-banner__logo'>
            <Logo />
            { page.acf.advocacy && <img src={AdvocacyLogo} alt='WHITEFOX Advocacy' /> }
          </div>
        </section>
        <section className='agent-header'>
          <div className='agent-header__inner'>
            <div className='agent-header__left'>
              <h1>{team.title}</h1>
              <h2>{team.acf.jobTitle || team.teamData.position}</h2>
              <ul>
                { mobile &&
                  <li>
                    <Link to={`tel:${mobile}`}>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.0656738 4.71484H8.56331V5.81116H0.0656738V4.71484Z" fill="#64656A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.20636 8.93666L5.43848 8.16878L8.34453 5.26325L5.43848 2.35773L6.20636 1.58984L9.87925 5.26326L6.20636 8.93666Z" fill="#64656A"/>
                      </svg>
                      { process.env.GATSBY_LOCATION === 'aus' ? parsePhoneNumberFromString(mobile, 'AU').formatNational() : mobile }
                    </Link>
                  </li>
                }
                { team.acf.instagram &&
                  <li>
                    <Link to={team.acf.instagram}>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.0656738 4.71484H8.56331V5.81116H0.0656738V4.71484Z" fill="#64656A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.20636 8.93666L5.43848 8.16878L8.34453 5.26325L5.43848 2.35773L6.20636 1.58984L9.87925 5.26326L6.20636 8.93666Z" fill="#64656A"/>
                      </svg>
                      Instagram
                    </Link>
                  </li>
                }
                <li>
                  <Link to={`mailto:${email}`}>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M0.0656738 4.71484H8.56331V5.81116H0.0656738V4.71484Z" fill="#64656A"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M6.20636 8.93666L5.43848 8.16878L8.34453 5.26325L5.43848 2.35773L6.20636 1.58984L9.87925 5.26326L6.20636 8.93666Z" fill="#64656A"/>
                    </svg>
                    { email }
                  </Link>
                </li>
              </ul>
              { team.acf.thumbnailImage && <img src={team.acf.thumbnailImage.localFile.publicURL} alt={team.title} /> }
              {team.acf.content && <div>{parse(team.acf.content)}</div> }
            </div>
            <div className='agent-header__right'>
              { team.acf.thumbnailImage && <img src={team.acf.thumbnailImage.localFile.publicURL} alt={team.title} /> }
            </div>
          </div>
        </section>
        { team.acf.videos?.length > 0 &&
          <section className='im-expertise im-branding im-videos'>
            <div className='im-expertise__inner'>
              <div className='im-expertise__item'>
                <div className='im-expertise__header'>
                  <h3>{team.acf.videosTitle ? team.acf.videosTitle : 'Videos'}</h3>
                </div>
                <div className='im-expertise__gallery'>
                  <Slider {...videosSettings}>
                    { team.acf.videos.map((item, x) => (
                      <div className='im-expertise__video' key={x} onClick={
                        () => {
                          this.setState({ isLightboxOpen: true, lightboxIndex: x })
                        }
                      }>
                        <img src={item.thumbnail.localFile.publicURL} alt={team.title} />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </section>
        }
        { !page.acf.advocacy &&
          <section className='im-expertise im-branding'>
            <div className='im-expertise__inner'>
              <div className='im-expertise__item'>
                <div className='im-expertise__header'>
                  { settings.imBranding.title && <h3>{parse(settings.imBranding.title)}</h3> }
                  <img src={settings.imBranding.gallery[0].publicUrl} alt={settings.imBranding.title} />
                </div>
                <div className='im-expertise__gallery'>
                  <Slider {...sliderSettings}>
                    { settings.imBranding.gallery.slice(1, settings.imBranding.gallery.length).map((img, x) => (
                      <img key={x} src={img.publicUrl} alt={settings.imBranding.title} />
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </section>
        }
        <section className='im-pillars'>
          <div className='im-pillars__inner'>
            { settings.imPillars.title && <h2>{parse(settings.imPillars.title)}</h2> }
            { settings.imPillars.items?.length > 0 &&
              <div className='im-pillars__items'>
                <Slider {...pillarSettings}>
                  { settings.imPillars.items.map((el, i) => (
                    <div className='im-pillars__item' key={i}>
                      <img className='im-pillars__image--mobile' src={el.mobileImage.publicUrl} alt={el.title} />
                      <img className='im-pillars__image--desktop' src={el.image.publicUrl} alt={el.title} />
                      <h4>{el.title} <span>{el.subtitle}</span></h4>
                      <div>{parse(el.content)}</div>
                    </div>
                  ))}
                </Slider>
              </div>
            }
          </div>
        </section>
        { page.acf.advocacy && settings.imTimeline.title && settings.imTimeline.items?.length > 0 && 
          <section className='timeline'>
            <div className="timeline__inner container">
              { settings.imTimeline.title && <h3 dangerouslySetInnerHTML={{ __html: settings.imTimeline.title }} /> }
              <div className="timeline__items">
                { settings.imTimeline.items?.map((item, index) => (
                  <div className="timeline__item" key={index}>
                    <Fade bottom distance='25px'>
                      <div className="timeline__image">
                        <img src={item.image.localFile.publicURL} alt={item.title} />
                      </div>
                      <div className="timeline__content">
                        <h4>{item.title}</h4>
                        <div dangerouslySetInnerHTML={{ __html: item.content }} />
                      </div>
                    </Fade>
                  </div>
                )) }
              </div>
            </div>
          </section>
        }
        <section className='im-difference'>
          <div className='im-difference__inner'>
            <div className='im-difference__image'>
              <img src={settings.imDifference.image.publicUrl} alt={settings.imDifference.title} />
            </div>
            <div className='im-difference__content'>
              { settings.imDifference.title && <h2>The industry influencer</h2> }
              <img src={settings.imDifference.image.publicUrl} alt={settings.imDifference.title} />
              { settings.imDifference.content && <div className='im-word__text'>{parse(settings.imDifference.content)}</div> }
            </div>
          </div>
        </section>
        <section className='im-views'>
          <div className='im-views__inner'>
            <ul className='im-views__items'>
              <li><span>Average Listing Views*</span></li>
              <li>
                <h4>WHITEFOX</h4>
                <p>{settings.imViews.whitefox}</p>
              </li>
              <li>
                <h4>Industry Average</h4>
                <p>{settings.imViews.average}</p>
              </li>
              <li>
                <h4>Comparison</h4>
                <p>
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5 20.125L12.5 3.875M12.5 3.875L19 10.375M12.5 3.875L6 10.375" stroke="#64656A" stroke-linecap="square"/>
                  </svg>
                  {settings.imViews.comparison}
                </p>
              </li>
            </ul>
            <p className='im-views__footnote'>{parse(settings.imViews.footnote)}</p>
          </div>
        </section>
        <section className='im-influencer'>
          <div className='im-influencer__inner'>
            <ul className='im-influencer__items'>
              { settings.imInfluencer.items?.length > 0 && settings.imInfluencer.items.map((el, i) => (
                <li key={i}>
                  <h4>{el.label}</h4>
                  <p>{el.value}</p>
                </li>
              ))}
            </ul>
            <img src={settings.imInfluencer.image.publicUrl} alt='Influencer' />
          </div>
        </section>
        <section className='im-expertise'>
          <div className='im-expertise__inner'>
            { settings.imExpertise.items?.length > 0 && settings.imExpertise.items.map((el, i) => (
              <div className='im-expertise__item' key={i}>
                <div className='im-expertise__header'>
                  { el.title && <h3>{parse(el.title)}</h3> }
                  { el.subtitle && <h4>{parse(el.subtitle)}</h4> }
                  { el.content && <p>{parse(el.content)}</p> }
                </div>
                <div className='im-expertise__gallery'>
                  <Slider {...sliderSettings}>
                    { el.gallery.map((img, x) => (
                      <img key={x} src={img.publicUrl} alt={el.title} />
                    ))}
                  </Slider>
                </div>
              </div>
            ))}
          </div>
        </section>
        { page.acf.advocacy && process.env.GATSBY_LOCATION !== 'nz' && <div className='im-bought'><BoughtBlocks /></div> }
        { !page.acf.advocacy && <AgentListings current_properties={this.props.data.current.edges} sold_properties={this.props.data.sold.edges} /> }
        <section className='im-word'>
          <div className='im-word__inner'>
            <div className='im-word__content'>
              { settings.imWord.title && <h2>{parse(settings.imWord.title)}</h2> }
              { settings.imWord.subtitle && <h3>{parse(settings.imWord.subtitle)}</h3> }
              { settings.imWord.content && <div className='im-word__text'>{parse(settings.imWord.content)}</div> }
              <div className='im-word__signature'>
                { settings.imWord.signature && <img src={settings.imWord.signature.publicUrl} alt='signature' /> }
                <div>
                  <p>Marty Fox</p>
                  <p>Founder &amp; CEO</p>
                </div>
              </div>
            </div>
            <div className='im-word__image'>
              <img src={settings.imWord.image.publicUrl} alt={settings.imWord.title} />
            </div>
          </div>
        </section>
        <section className='im-offices'>
          <div className='im-offices__inner'>
            <h2>Locations</h2>
          </div>
          <Offices title={process.env.GATSBY_LOCATION === 'aus' ? 'Australia' : 'New Zealand'} offices={process.env.GATSBY_LOCATION === 'aus' ? settings.imOffices.aus : settings.imOffices.nz} />
          <Offices title={process.env.GATSBY_LOCATION === 'aus' ? 'New Zealand' : 'Australia'} offices={process.env.GATSBY_LOCATION === 'aus' ? settings.imOffices.nz : settings.imOffices.aus} />
        </section>
        <section className='single-agent__disclaimer'>
          <div className='single-agent__disclaimer-logo'>
            <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M21.8496 21.6279H45.8204V26.3421H26.8848V37.3972H45.8541V42.1113H26.8848V54.0056H46.0047V58.7197H21.8496V21.6279Z" fill="#3C3C3C"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M58.0827 21.6279H34.1119V26.3421H53.0474V37.3972H34.0782V42.1113H53.0474V54.0056H33.9275V58.7197H58.0827V21.6279Z" fill="#3C3C3C"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M39.966 80.0915C17.9288 80.0915 0 62.1838 0 40.1727C0 18.1616 17.9288 0.253906 39.966 0.253906C62.0032 0.253906 79.9321 18.1616 79.9321 40.1727C79.9321 62.1838 62.0032 80.0915 39.966 80.0915M39.966 3.52431C19.7349 3.52431 3.27528 19.9645 3.27528 40.1717C3.27528 60.379 19.7349 76.8192 39.966 76.8192C60.1971 76.8192 76.6568 60.379 76.6568 40.1717C76.6568 19.9645 60.1971 3.52431 39.966 3.52431" fill="#3C3C3C"/>
            </svg>
          </div>
          <div className='single-agent__inner'>
            { settings.imDisclaimer && parse(settings.imDisclaimer) }
          </div>
        </section>
        {this.state.isLightboxOpen && (
          <div className={`sp__lightbox active`}>
            <div className="sp__lightbox__inner">
              <svg
                onClick={this.closeLightbox}
                className="close"
                style={{ position: "fixed", top: 10, right: 10 }}
                width="25px"
                height="25px"
                viewBox="0 0 25 25"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g stroke="none" strokeWidth="1" fill="#FFFFFF" fillRule="evenodd">
                  <path d="M12.4893787,24.9492612 C5.60275148,24.9492612 1.0658141e-14,19.3531028 1.0658141e-14,12.4746158 C1.0658141e-14,5.59615839 5.60275148,-1.42108547e-14 12.4893787,-1.42108547e-14 C19.3760059,-1.42108547e-14 24.978787,5.59615839 24.978787,12.4746158 C24.978787,19.3531028 19.3760059,24.9492612 12.4893787,24.9492612 M12.4893787,1.02231087 C6.16715976,1.02231087 1.02352071,6.15986998 1.02352071,12.4746158 C1.02352071,18.7893913 6.16715976,23.9269504 12.4893787,23.9269504 C18.8115976,23.9269504 23.9552367,18.7893913 23.9552367,12.4746158 C23.9552367,6.15986998 18.8115976,1.02231087 12.4893787,1.02231087"></path>
                  <g transform="translate(7.000000, 7.000000)">
                    <polygon points="11 0.70490208 10.2951656 0 5.49999993 4.79509779 0.704834305 0 0 0.70490208 4.7951655 5.49999987 0 10.2950977 0.704834305 11 5.49999993 6.20490195 10.2951656 11 11 10.2950977 6.20483437 5.49999987"></polygon>
                  </g>
                </g>
              </svg>
              <div>
                <Plyr
                  type="youtube"
                  videoId={team.acf.videos[this.state.lightboxIndex].youtubeId}
                  autoplay={typeof window !== "undefined" && window.innerWidth < 900 ? false : true}
                  urls={{
                    youtube: {
                      api: `https://noembed.com/embed?url=${0}`,
                    },
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
}


export const imQuery = graphql`
  query ImTemplateQuery ($id: String!, $agent_id: String!) {
    wpIm(id: {eq: $id}) {
      title
      seo {
        ...WpSeo
      }
      acf {
        office
        advocacy
      }
    }
    wpTeam(id: {eq: $agent_id}) {
      title
      slug
      boxId
      teamData {
        first_name
        last_name
        mobile
        email
        position
      }
      acf {
        thumbnailImage {
          localFile { publicURL }
          altText
        }
        bannerImage {
          localFile { publicURL }
          altText
        }
        firstName
        lastName
        email
        mobile
        jobTitle
        licenseTitle
        video
        content
        instagram
        facebook
        videos {
          thumbnail {
            localFile { 
              publicURL 
            }
          }
          youtubeId
        }
        videosTitle
      }
    }
    current: allWpProperty(
      filter: {
      propertyData: {
        website_status: { eq: "current" }
      }
    }
    ) {
      edges {
        node {
          ...PropertyCard
        }
      }
    }
    sold: allWpProperty(
      filter: {
        propertyData: {
          website_status: { eq: "sold" }
        }
      }
    ) {
      edges {
        node {
          ...PropertyCard
        }
      }
    }
    wp {
      siteSettings {
        acf {
          imVideo
          imWord {
            title
            subtitle
            content
            signature {
              publicUrl
            }
            image {
              publicUrl
            }
          }
          imTimeline {
            title
            items {
              image {
                localFile {
                  publicURL
                }
              }
              title
              content
            }
          }
          imPillars {
            title
            items {
              image {
                publicUrl
              }
              mobileImage {
                publicUrl
              }
              title
              subtitle
              content
            } 
          }
          imDifference {
            title
            image {
              publicUrl
            }
            title
            content
          }
          imViews {
            whitefox
            average
            comparison
            footnote
            image {
              publicUrl
            }
            mobileImage {
              publicUrl
            }
          }
          imObvious {
            title
            subtitle
            image {
              publicUrl
            }  
          }
          imInfluencer {
            topImage {
              publicUrl
            }
            title
            items {
              label
              value
            }
            featuredIn {
              publicUrl
            }
            image {
              publicUrl
            }
          }
          imExpertise {
            items {
              title
              subtitle
              content
              gallery {
                publicUrl
              }
            }
          }
          imBranding {
            title
            gallery {
              publicUrl
            }
          }
          imDisclaimer
          imOffices {
            aus {
              ... on WpOffice {
                title
                acf {
                  featuredImage {
                    localFile { 
                      publicURL 
                    }
                  }
                  gallery {
                    localFile {
                      publicURL
                    }
                  }
                  phone {
                    title
                    url
                  }
                  email {
                    title
                    url
                  }
                  formSubmissionEmails
                  address
                }
              }
            }
            nz {
              ... on WpOffice {
                title
                acf {
                  featuredImage {
                    localFile { 
                      publicURL 
                    }
                  }
                  gallery {
                    localFile {
                      publicURL
                    }
                  }
                  phone {
                    title
                    url
                  }
                  email {
                    title
                    url
                  }
                  formSubmissionEmails
                  address
                }
              }
            }
          }
        }
      }
    }
  }
`

export default ImTemplate